import styled, { css } from 'styled-components';
import {
	EmailShareButton,
	FacebookShareButton,
	TwitterShareButton,
	WhatsappShareButton,
} from 'react-share';
import IconButton from '@sy/app-client/src/ssrAdapter/components/IconButton';

export const BigScreenWrapper = styled.div`
	margin: 88px 20px 108px 0;
	display: flex;
	flex-direction: column;
	gap: 8px;
	position: sticky;
	top: 88px;
	align-self: baseline;
`;

export const SmallScreenWrapper = styled.div`
	position: fixed;
	bottom: 16px;
	right: 16px;
	display: flex;
	flex-direction: column-reverse;
	align-items: center;
	gap: 16px;
	z-index: 1;
`;

type SmallScreenButtonsWrapperType = {
	expanded?: boolean;
};
export const SmallScreenButtonsWrapper = styled.div<SmallScreenButtonsWrapperType>`
	height: ${({ expanded }) => (expanded ? '232px' : '0')};
	overflow: hidden;
	border-radius: 32px;
	box-shadow: ${({ theme }) => theme.shadows.subtle};
	background-color: ${({ theme }) => theme.colors.white};
	transition: height 0.15s ease-in;
`;

export const SmallScreenButtonsList = styled.div`
	display: flex;
	flex-direction: column-reverse;
	gap: 8px;
	padding: 16px 8px;
`;

export const SmallScreenShareButton = styled(IconButton)`
	width: 48px;
	height: 48px;
	border-radius: 50%;
	background-color: ${({ theme }) => theme.colors.grey[900]};

	svg {
		fill: ${({ theme }) => theme.colors.white};
	}

	&:hover,
	&:active {
		background-color: ${({ theme }) => theme.colors.grey[400]};
	}
`;

export const ShareButton = styled(IconButton)`
	svg {
		fill: ${({ theme }) => theme.colors.grey[900]};
	}
`;

export const ShareButtonIcon = styled.div`
	width: 44px;
	height: 44px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	background: none;
	border-radius: 4px;
	text-decoration: none;
	transition: all 0.15s;

	&:hover {
		background-color: ${({ theme }) => theme.colors.grey[200]};
	}

	svg {
		fill: ${({ theme }) => theme.colors.grey[900]};
	}
`;

const shareButtonCss = css`
	width: 44px;
	height: 44px;

	&:focus {
		box-shadow: ${({ theme }) => theme.misc.focusShadow};
	}
`;

export const StyledEmailShareButton = styled(EmailShareButton)`
	${shareButtonCss}
`;

export const StyledFacebookShareButton = styled(FacebookShareButton)`
	${shareButtonCss}
`;

export const StyledTwitterShareButton = styled(TwitterShareButton)`
	${shareButtonCss}
`;

export const StyledWhatsappShareButton = styled(WhatsappShareButton)`
	${shareButtonCss}
`;
